export type TemplateKind =
  | 'birthday'
  | 'trip'
  | 'graduation'
  | 'wedding'
  | 'memorial'
  | 'reunion'
  | 'holiday'
  | 'general';

export interface EventTemplateConfig {
  kind: TemplateKind;
  label: string;
  icon: string;
  titlePlaceholder: string;
  noun: string;
}

export const DEFAULT_TEMPLATE_KIND: TemplateKind = 'general';

export const EVENT_TEMPLATES: EventTemplateConfig[] = [
  { kind: 'birthday', label: 'Birthday', icon: '🎂', titlePlaceholder: "e.g. Grandma's 80th Birthday", noun: 'birthday' },
  { kind: 'trip', label: 'Vacation / Trip', icon: '✈️', titlePlaceholder: 'e.g. Summer Trip to Maine', noun: 'trip' },
  { kind: 'graduation', label: 'Graduation', icon: '🎓', titlePlaceholder: "e.g. Jake's College Graduation", noun: 'graduation' },
  { kind: 'wedding', label: 'Wedding', icon: '💍', titlePlaceholder: "e.g. Sarah & Tom's Wedding", noun: 'wedding' },
  { kind: 'memorial', label: 'Memorial', icon: '🕊️', titlePlaceholder: "e.g. Celebrating Grandpa's Life", noun: 'memorial' },
  { kind: 'reunion', label: 'Reunion', icon: '👨‍👩‍👧‍👦', titlePlaceholder: 'e.g. Smith Family Reunion', noun: 'reunion' },
  { kind: 'holiday', label: 'Holiday', icon: '🎄', titlePlaceholder: 'e.g. Christmas 2026', noun: 'holiday' },
  { kind: 'general', label: 'General / Other', icon: '📷', titlePlaceholder: 'e.g. Weekend at the Lake', noun: 'event' },
];

/** Resolves a possibly-null/unrecognized stored value to a real config — the single chokepoint for backward-compat rendering (null/unrecognized always reads as General). */
export function getEventTemplate(kind: string | null | undefined): EventTemplateConfig {
  return EVENT_TEMPLATES.find(t => t.kind === kind) ?? EVENT_TEMPLATES.find(t => t.kind === DEFAULT_TEMPLATE_KIND)!;
}
